import { render, staticRenderFns } from "./umEditor.vue?vue&type=template&id=2d34e5c4&"
import script from "./umEditor.vue?vue&type=script&lang=js&"
export * from "./umEditor.vue?vue&type=script&lang=js&"
import style0 from "./umEditor.vue?vue&type=style&index=0&id=2d34e5c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports